module.exports = __webpack_public_path__ + "static/img/1.6e38f023.png";